module.exports = __webpack_public_path__ + "img/right-mole.d8d0191b.png";